import { cx } from '@mage-ui/styled-system/css';
import { focus, footer, text } from '@mage-ui/styled-system/recipes';
import Link from 'next/link';

export const FooterMenu = ({ data, texts, ...props }) => {
  const links = data?.relations?.Links || [];

  return (
    <nav aria-label={texts.a11yLabelNav}>
      <ul className={footer().menu} {...props}>
        {links?.map((item) => (
          <li key={item?.meta?.key}>
            <Link
              href={item?.meta?.link || '#'}
              className={cx(
                text({ size: '1', weight: 'bold' }),
                footer().link,
                focus(),
              )}
            >
              {item?.fields?.title}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};
